import React from 'react';

import { Chapter } from './Chapter';

import chapterOne from '../../../main/assets/images/fpvAce/fpv-ace-chapter-one.webp';
import chapterTwo from '../../../main/assets/images/fpvAce/fpv-ace-chapter-two.webp';
import chapterThree from '../../../main/assets/images/fpvAce/fpv-ace-chapter-three.webp';

const CHAPTER_DATA = [
  {
    id: 1,
    image: chapterOne,
    title: 'Chapter 1',
    subtitle: 'drone sim mastery',
    description:
      'Master the art of flying with Orqa FPV.SkyDive, realistic drone simulator.',
    ctaUrl: 'https://shop.orqafpv.com/',
    alt: "First Chapter from Product's Bundle",
  },
  {
    id: 2,
    image: chapterTwo,
    title: 'Chapter 2',
    subtitle: 'los take off',
    description:
      'Take off to new adventures, test your skills with a lightweight, resistant and easy-to-use drone to unleash your flying potential.',
    ctaUrl: 'https://shop.orqafpv.com/',
    alt: "Second Chapter from Product's Bundle",
  },
  {
    id: 3,
    image: chapterThree,
    title: 'Chapter 3',
    subtitle: 'fpv dive in',
    description:
      'Dive into the immersive world of FPV flying, discover a whole new perspective and experince the thrill of flying with both your feet safely on the ground.',
    ctaUrl: 'https://shop.orqafpv.com/',
    alt: "Third Chapter from Product's Bundle",
  },
];

export const Chapters = () => {
  return (
    <div style={{ position: 'relative' }} className="fpv-ace-container">
      {CHAPTER_DATA.map(chapter => (
        <Chapter
          key={`chapter-${chapter.id}`}
          image={chapter.image}
          title={chapter.title}
          subtitle={chapter.subtitle}
          description={chapter.description}
          ctaUrl={chapter.ctaUrl}
          alt={chapter.alt}
        />
      ))}
    </div>
  );
};
